(function () {
  const parseTargetDate = (el) => {
    const isMock = el.getAttribute('data-enable-mock-timer') === 'true';

    if (isMock) {
      const days = Number(el.getAttribute('data-enable-mock-picker-day'));
      const hours = Number(el.getAttribute('data-enable-mock-picker-hours'));
      return new Date(Date.now() + (days * 24 + hours) * 60 * 60 * 1000);
    }

    const date = el.getAttribute('data-date');
    const time = el.getAttribute('data-time') || '00:00';
    const safeTime = time.length === 5 ? `${time}:00` : time;
    return new Date(`${date}T${safeTime}`);
  };

  const computeUnits = (distanceMs) => {
    const d = Math.max(0, distanceMs);
    return {
      days: Math.floor(d / (1000 * 60 * 60 * 24)),
      hours: Math.floor((d % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)),
      minutes: Math.floor((d % (1000 * 60 * 60)) / (1000 * 60)),
      seconds: Math.floor((d % (1000 * 60)) / 1000),
    };
  };

  const pad = (n) => String(n).padStart(2, '0');

  const updateDisplay = (els, units) => {
    if (els.days) els.days.textContent = pad(units.days);
    if (els.hours) els.hours.textContent = pad(units.hours);
    if (els.minutes) els.minutes.textContent = pad(units.minutes);
    if (els.seconds) els.seconds.textContent = pad(units.seconds);
  };

  const handleExpired = (el, els, completedMode, stop) => {
    stop();
    if (completedMode === 'hide_section') {
      const section = el.closest('section');
      if (section) section.style.display = 'none';
    } else if (completedMode === 'show_text') {
      if (els.countdown) els.countdown.style.display = 'none';
      if (els.endInfo) els.endInfo.style.display = 'flex';
    }
  };

  const initCountdown = (el) => {
    if (!el || el.tagName.toLowerCase() !== 'countdown-timer') return;

    const targetDate = parseTargetDate(el);
    const completedMode = el.getAttribute('data-completed');
    const els = {
      countdown: el.querySelector('.countdown__main'),
      endInfo: el.querySelector('.countdown__end-info'),
      days: el.querySelector('.countdown_block_days'),
      hours: el.querySelector('.countdown_block_hours'),
      minutes: el.querySelector('.countdown_block_minutes'),
      seconds: el.querySelector('.countdown_block_seconds'),
    };

    let intervalId;

    const stop = () => clearInterval(intervalId);

    const tick = () => {
      const distance = targetDate.getTime() - Date.now();
      if (distance < 0) {
        handleExpired(el, els, completedMode, stop);
        return;
      }
      updateDisplay(els, computeUnits(distance));
    };

    tick();
    intervalId = setInterval(tick, 1000);
  };

  document.querySelectorAll('countdown-timer').forEach(initCountdown);

  document.addEventListener('shopify:section:load', (event) => {
    event.target.querySelectorAll('countdown-timer').forEach(initCountdown);
  });
})();
